// extracted by mini-css-extract-plugin
export default {"input":"FormTextInput_input__nd8Yb","label":"FormTextInput_label__ZavSZ"};